export interface resource_faq_response{
    id:number;
    question:string;
    answer:string;
    order:number;
}
export class ResourceFAQ{
    public id:number = 0;
    public question:string = '';
    public answer:string = '';
    public order:number = 0;
    public active: boolean = false
    public map(data:resource_faq_response){
        this.id = data.id;
        this.question = data.question;
        this.answer = data.answer;
        this.order = data.order;

        return this;
    }
    public responsify():resource_faq_response{
        return {
            id:this.id,
            question:this.question,
            answer: this.answer,
            order:this.order,
        }
    }
    public static create(data:resource_faq_response){
        let r = new this;
        r.map(data);
        return r;
    }
}